import React, { useState,useEffect } from 'react'
import i18n from '@dhis2/d2-i18n'
import classes from '../../App.module.css'
import { makeStyles } from '@material-ui/core/styles';
import { apiServices } from '../../services/apiServices'
import SearchBar from '../../component/searchbar/SearchBar';
import CaseList from './NewThemeCaseList'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import Pagination from "@material-ui/lab/Pagination";
import Grid from '@material-ui/core/Grid';
import {
    Button, 
    ButtonStrip,
    Divider,
    InputFieldFF, 
    SingleSelectFieldFF, 
    ReactFinalForm,
    hasValue,
    InputField,
    CircularLoader,
    CenteredContent
} from '@dhis2/ui';
import { withTranslation, Trans , useTranslation } from 'react-i18next';
import swal from 'sweetalert'
import OfflineDb from '../../db'
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
//import {Configuration} from '../../assets/data/config'
import '../../assets/css/customstyles.css'
import '../../assets/css/theme_grey.css'
import '../../assets/css/theme_blue.css'
import '../../assets/css/theme_green.css'
import '../../assets/css/theme_red.css'
import _ from 'lodash'
import FooterMenu from '../../component/layout/FooterMenu'
import Customcasescard from './NewThemeCustomcasescard.js';

const {Form, Field } = ReactFinalForm

function Cases(){
    const [sessionUserBoValue,setSessionUserBoValue] = React.useState(null)
    const [progarmData,setProgarmData] = useState(null)
    const [customSearch,setCustomSearch] = useState([])
    const [UICSearch,setUICSearch] = useState([])
    const [input, setInput] = useState('');
    const [searchResult,setSearchResult] = useState([])
    const [searchAllResult,setSearchAllResult] = useState([])
    const [searchFilterResult,setSearchFilterResult] = useState([])
    const [value,setValue] = useState([])
    // const [loading,setGlobalSpinner] = useState(false)
    const {t} = useTranslation()
    const [viewType, setViweType] = useState('list')
    const [tabViewType, setTabViewType] = useState('all')
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [clientTypeID, setClientTypeID] = useState(null)
    //pagination code
    //const itemsPerPage = Configuration.pagination.itemsPerPage
    const [page, setPage] = useState(1);
    const [noOfPages,setNoOfPages] = useState(0)
    const [Configuration,setConfiguration] = useState(null);
    const [expanded2, setExpanded2] = useState(false);
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded2(isExpanded ? panel : false);
    };
    const [givenNameID, setGivenNameID] = useState(null)
    async function getMetaData(){
        let metadata = await OfflineDb.getDataFromPouchDB('metaData')
        setProgarmData(metadata.data)
        
        let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
        setSessionUserBoValue(loginDetails.data)

        let configurations = await OfflineDb.getDataFromPouchDB('configurations')
        setConfiguration(configurations.data.configuration)
    }
    useEffect(()=>{
        getMetaData()      
        OfflineDb.removeDataFromPouchDB('activeCaseDetails')
        OfflineDb.removeDataFromPouchDB('activeCaseFormData')
        OfflineDb.removeDataFromPouchDB('linkContactFlag')
        OfflineDb.setDataIntoPouchDB('transferFlag', {type:null})
    },[])
    
    //once user bco is set call getContactList function
    useEffect(()=>{
        if(sessionUserBoValue != null && Configuration != null){
            getCasesList()
        }
    },[sessionUserBoValue, Configuration])
    // useEffect(()=>{
    //     if(searchResult.length > 0 && Configuration != null){
    //         setNoOfPages(Math.ceil(searchResult[1].length / Configuration.pagination.itemsPerPage))
    //     }
    // },[searchResult,Configuration])

    useEffect(() => {
        if(progarmData !=null){
            getCustomVariableIds()
        }
    }, [progarmData])
    
    function getCustomVariableIds(){
        progarmData.programs[0].programTrackedEntityAttributes.map(regField => {
            let fieldName = regField.trackedEntityAttribute.description ? regField.trackedEntityAttribute.description : regField.trackedEntityAttribute.formName ? regField.trackedEntityAttribute.formName : regField.trackedEntityAttribute.displayName
            if (fieldName.trim().toLocaleLowerCase() == "client type") {
                setClientTypeID(regField.trackedEntityAttribute.id)
            }
            if (fieldName.trim().toLocaleLowerCase() == "given name") {
                setGivenNameID(regField.trackedEntityAttribute.id)
            }
        })
    }
    
    function getCasesList(param)  {
        //localStorage.removeItem('trackedEntityInstance')
        setGlobalSpinner(true)        
        let orgID = sessionUserBoValue.organisationUnits[0].id, //`UuYrI1twhmN`,
            programID = sessionUserBoValue.programs[0], //`nSy7PFqQykt`, 
            searchQuery = ``
        
        for (var i in param) {
            searchQuery += `&attribute=${i}:LIKE:${param[i]}`
        }
        //console.log("sessionUserBoValue ",sessionUserBoValue);
        
        //let subURL = 'trackedEntityInstances/query.json?ou='+ orgID +'&ouMode=SELECTED&program='+ programID +'&pageSize='+Configuration.pagination.fetchNoOfRecords+'&page=1&totalPages=false'
                   //'trackedEntityInstances/query.json?ou='+ orgID +'&ouMode=SELECTED&&order=created:desc&program='+ programID +'&pageSize=50&page=1&totalPages=false'
                   //&pageSize=50&page=1&totalPages=false
        //let subURL = 'referral/myclient/list?programid='+programID
        let subURL = 'referral/myclient/userbylist?programid='+programID+'&userid='+sessionUserBoValue.userCredentials.username
        apiServices.getAPI(subURL).then(res => { 
           
            let searchArray = []
            let headers = []
            let rowValues = []
            // try{
            //     res.data.headers.map(ele => {
            //         if(ele.column.includes('_')){
            //             let item = ele.column.split('_')
            //             ele.column = item[1]
            //         }
            //     })
            // }catch(e){
            //     console.log(e);
            // }
            // searchArray.push(res.data.headers)
            // searchArray.push(res.data.rows.reverse())
            if(res.data && res.data.data && res.data.data.length > 0){
                searchArray = res.data.data
            }else{
                swal({
                    title: "Alert",
                    text: t("No records found"),
                    icon: "warning",
                    button: "Close",
                });
            }
            setGlobalSpinner(false)
            setSearchResult(searchArray)
            setSearchAllResult(searchArray)
            setSearchFilterResult(searchArray)
            OfflineDb.setDataIntoPouchDB('myclients',searchArray);
        }).catch(error => {
            setGlobalSpinner(false)
            swal({
                title: "Error",
                text: t("Sorry something went wrong, please try again later"),
                icon: "error",
                button: "Close",
              });
        })
        
    }
    
    const handleViewChange = (event,newValue) => {
        setViweType(newValue);
    };

    const handleTabViewChange = (event,newValue) => {
        setInput('');
        setTabViewType(newValue);
        setExpanded2(false)
        let filteredData = searchAllResult
        if(newValue == "LTBI" || newValue == "TB"){
            let data = _.filter(searchAllResult,{types:newValue})
            filteredData = data
        }else if(newValue == "pending"){
            let data = _.filter(searchAllResult,{types:null})
            let newData = []
            if(data && data.length > 0){
                data.map(ele => {
                    if(ele[clientTypeID] != Configuration.ltbiLinkVariables.index){
                        newData.push(ele)
                    }
                })
            }
            filteredData = newData
        }
        setSearchResult(filteredData)
        setSearchFilterResult(filteredData)
    };
    
    const updateInput = (input) => {
        setInput(input);
        let filteredList = []
        setGlobalSpinner(true)
        
        if(input && input.length >= 3){
            console.log("searchFilterResult ",searchFilterResult);
            searchFilterResult.map(function(objectKey, index) {
                // objectKey.map(function(data, j) {
                //     if(data.toLowerCase().indexOf(input.toLowerCase()) > -1){
                //         filteredList.push(objectKey)
                //     }
                // })
                if(objectKey[givenNameID] && objectKey[givenNameID].toLowerCase().indexOf(input.toLowerCase()) > -1){
                    filteredList.push(objectKey)
                }
            })
            // let headerEle = searchAllResult[0]
            // let filterSearchArray = [];
            // filterSearchArray.push(headerEle)
            // filterSearchArray.push(filteredList)
            setSearchResult([]);
            setTimeout(function(){
                setGlobalSpinner(false)
                setSearchResult(filteredList)
            },500)
        }else{
            if(input.length == 0){
                // let headerEle = searchAllResult[0]
                // let filterSearchArray = [];
                // filterSearchArray.push(headerEle)
                // filterSearchArray.push(searchAllResult)
                setSearchResult([]);
                setTimeout(function(){
                    setGlobalSpinner(false)
                    setSearchResult(searchAllResult)
                },1000)
            }else{
                setGlobalSpinner(false)
            }
        }

        //if(filteredList.length > 0){
            
        
        
    }
   
    const loadViewToggleButtons = ()=>{
        return (
            <div className=" customregistrationtabs regcasetabs ">
                <AppBar position="static">
                    <Tabs value={viewType} onChange={handleViewChange}>
                        <Tab value="list" label={t('List View')}></Tab>
                        <Tab value="card" label= {t('Card View')}></Tab>
                    </Tabs>
                </AppBar>
            </div>
            
        )
    }

    const loadTabViewButtons = ()=>{
        return (
            <div className=" customregistrationtabs regcasetabs ">
                <AppBar position="static">
                    <Tabs value={tabViewType} onChange={handleTabViewChange}>
                        <Tab value="all" label={t('All')}></Tab>
                        <Tab value="LTBI" label= {t('TBI +ve')}></Tab>
                        <Tab value="TB" label= {t('TB +ve')}></Tab>
                        <Tab value="pending" label= {t('Pending')}></Tab>
                    </Tabs>
                </AppBar>
            </div>
            
        )
    }
    const handlePageChange = (event, value) => {
        setPage(value);
    }
    const renderClientList = (row)=>{
        console.log("row",row);
        // return (
        //     <Grid item xs={12} sm={12} md={12} className="knowkedgelistcontainer">
        //       <Accordion square expanded={row.expanded === `panel1${row.index}`} onChange={row.handleChange(`panel1${row.index}`)}>
        //       <AccordionSummary
        //         expandIcon={<ExpandMoreIcon />}
        //         aria-controls={`panel1bh-content${row.index}`}
        //         id={`panel1bh-header${row.index}`}
                
        //       >
        //         <Typography className={classes.heading} style={{paddingTop:"10px"}}><EventNoteIcon /></Typography>
        //           <Typography style={{padding: '10px 15px'}}>
        //             {clietName}
        //             </Typography>
        //       </AccordionSummary>
        //         <AccordionDetails>
        //         {/* alertsdetailholder */}
        //           <div className="">
        //           <Customcaseslist row={row} viewType={row.viewType}></Customcaseslist>
        //           <p className="alerts_profilebtn_holder caselistviewbtnholder myClientsCaseList">
        //             <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn" onClick={seeIndividualRecordClick}>
        //               <VisibilityIcon /><span className="ml-10px"></span>
        //             </Button>
        //             <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px" onClick={UpdateRecordClick}>
        //               <EditIcon /> <span className="ml-10px"></span>
        //             </Button>
        //             { 
        //               Configuration.myclients && Configuration.myclients.enableDownloadReport 
        //                 ? 
        //                   <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px" onClick={downlaodReport}>
        //                     <GetAppIcon /> <span className="ml-10px"></span>
        //                   </Button>
        //                 :
        //                   <> </>  
        //             }
                    
        //             {clientType && clientType.toLocaleLowerCase() == 'index' ?
        //               <>
        //                 <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px hide1" onClick={getIndividualsList}>
        //                   <PeopleAltIcon />{/* <span className="ml-10px">{t('Linked contacts')}</span> */}
        //                 </Button>
        //                 <Button variant="contained" color="primary" disableElevation className="infoviewmorebtn ml-10px hide1" onClick={addContcat}>
        //                   <PersonAddIcon />{/* <span className="ml-10px">{t('Add contact')}</span> */}
        //                 </Button>
        //               </>
        //             :<></>
        //             }
        //           </p>
        //         </div>
        //       </AccordionDetails>
        //     </Accordion>
        //     </Grid>
        //   )
    }
    return (            
        <section className="searchcustombg searchtabmaindiv myclientspage"
                style={{
                    // backgroundColor: '#fff',
                    flexGrow: 1,
                    padding: 0,
                    
                }}
        >
            
            <FooterMenu></FooterMenu>
            <div className="searchformcontainer">
                <p className="searchformheading">
                    <span><Trans>My Clients</Trans></span>
                </p>
                
                <SearchBar 
                keyword={input} 
                setKeyword={updateInput}
                />
                { loadTabViewButtons() }
                {/* {searchResult.length > 0 ? loadTabViewButtons() : null} */}
                {/*console.log('searchResult', searchResult)*/}
                {
                    
                    searchResult.length > 0  && progarmData != null && Configuration != null?                          
                        // <CaseList
                        //     searchResult = {searchResult}
                        //     viewType={viewType}
                        //     metaData={progarmData}
                        //     page={page}
                        //     itemsPerPage={Configuration.pagination.itemsPerPage}
                        // /> 
                        searchResult.map((ele,i) => {
                            let searchHeader={} , key=i, headers =[], row = []
                            let itemIndex = Math.random * 9999
                            for(var item in ele){
                                let obj = {
                                    "name": item,
                                    "column": _.find(progarmData.trackedEntityAttributes,{id:item}) ? _.find(progarmData.trackedEntityAttributes,{id:item})["description"] ? _.find(progarmData.trackedEntityAttributes,{id:item})["description"] : _.find(progarmData.trackedEntityAttributes,{id:item})["formName"] : item,
                                    "type": "java.lang.String",
                                    "hidden": false,
                                    "meta": false
                                }
                                if(item == "instanceid"){
                                    headers = [obj, ...headers]
                                    row = [ele[item], ...row]
                                    itemIndex = ele[item]
                                }else{
                                    headers.push(obj)
                                    row.push(ele[item])
                                }
                                
                            }
                            searchHeader = headers
                            return  <Grid container spacing={3} className=""><Customcasescard 
                            index={itemIndex ? itemIndex : null} row={row} 
                            searchHeader={searchHeader} key={itemIndex} 
                            metaData={progarmData}
                            expanded={expanded2}
                            handleChange={(panel) => handleChange(panel)}
                            clientTabType={tabViewType ? tabViewType : null}
                        ></Customcasescard></Grid>
                            
                        })
                        
                        : null
                }
                
                {/* <Pagination
                    count={noOfPages}
                    page={page}
                    onChange={handlePageChange}
                    defaultPage={1}
                    //color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                    variant="outlined" 
                    shape="rounded" 
                /> */}
                
            </div>
                          
        </section>
    )
    
}
export default Cases;